import { Delete, SaveAsOutlined } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { defaultStore } from "shared/common/stores/defaultStore";
import { sidebarStore } from "shared/common/stores/sidebarStore";

export default function SaveOrDiscardLastChanges() {
  const { t } = useTranslation();

  const changeAlertSaveOrDiscardLastLayer = defaultStore(
    (state) => state.changeAlertSaveOrDiscardLastLayer
  );
  const changeAlertMessage = defaultStore((state) => state.changeAlertMessage);
  const viewer = defaultStore((state) => state.viewer);

  const activeEditModeLayers = sidebarStore(
    (state) => state.activeEditModeLayers
  );
  const changeActiveEditModeLayers = sidebarStore(
    (state) => state.changeActiveEditModeLayers
  );

  // discard changes on last active layer before closing it
  const discardChanges = () => {
    if (!viewer) return;
    if (activeEditModeLayers) {
      activeEditModeLayers.getLayerEditor()?.reset();
      activeEditModeLayers.reload();
      activeEditModeLayers.setEditMode(false);
    }
    changeAlertMessage({
      message: t("edit_feature.discarded_changes"),
      type: "info",
    });
    changeActiveEditModeLayers(
      viewer?.getScene().getLayerHandler().getActiveLayer()
    );
    changeAlertSaveOrDiscardLastLayer(false);
  };

  // save changes on last active layer before closing it
  const saveChanges = () => {
    if (!viewer) return;
    if (activeEditModeLayers) {
      activeEditModeLayers.save(
        () => {
          changeAlertMessage({
            message: t("edit_feature.save_message"),
            type: "success",
          });
          return {}; // Due to a TypeScript Bug in the SDK
        },
        () => {
          changeAlertMessage({
            message: t("edit_feature.error_on_save_message"),
            type: "error",
          });
          return {}; // Due to a TypeScript Bug in the SDK
        }
      );
      activeEditModeLayers.getLayerEditor()?.reset();
      activeEditModeLayers.reload();
      activeEditModeLayers.setEditMode(false);
    }

    changeActiveEditModeLayers(
      viewer?.getScene().getLayerHandler().getActiveLayer()
    );
    changeAlertSaveOrDiscardLastLayer(false);
  };

  return (
    <Box
      sx={{
        position: "absolute",
        width: "100%",
        height: "100%",
        zIndex: "100",
        paddingTop: "15%",
        display: "flex",
        justifyContent: "center",
        backgroundColor: "blackBackground.main",
      }}
    >
      <Box
        sx={{
          display: "flex",
          height: "fit-content",
          flexDirection: "column",
          paddingY: 2,
          paddingX: 4,
          margin: 2,
          gap: 2,
          backgroundColor: "white",
          borderRadius: "8px",
        }}
      >
        <Typography
          sx={{
            color: "darkblue.main",
          }}
        >
          {t("feature_alert.save_message")}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <Button
            onClick={discardChanges}
            variant="outlined"
            sx={{ color: "darkblue.main", borderColor: "darkblue.main" }}
          >
            <Delete fontSize="small" /> {t("feature_alert.save_discard_button")}
          </Button>
          <Button
            onClick={saveChanges}
            variant="outlined"
            sx={{ color: "darkblue.main", borderColor: "darkblue.main" }}
          >
            <SaveAsOutlined fontSize="small" />{" "}
            {t("feature_alert.save_save_button")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
